import { EntitiesVisualizer } from './entities-visualizer';
import Feature from 'ol/feature';
import Icon from 'ol/style/icon';
import Style from 'ol/style/style';

export const IconVisualizerType = 'IconVisualizer';

export class IconVisualizer extends EntitiesVisualizer {
	_iconSrc: Style;

	// constructor(iconPath: string, args: any) {
	constructor(args: any) {
		super(IconVisualizerType, args);
		// set icon
		this._iconSrc = new Style({
			image: new Icon({
				scale: 1,
				src: '/ansyn/assets/pinpoint-indicator.svg'
			}),
			zIndex: 100
		});
	}

	featureStyle(feature: Feature, resolution) {
		return this._iconSrc;
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layer-visualizers/icon.visualizer.ts